import { createRoot } from 'react-dom/client';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';

import { App } from './App';

const container = document.getElementById('root');

if (!container) {
  throw new Error('container not found!');
}
const root = createRoot(container);

(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: window.env.CARE_LAUNCH_DARKLY_ID,
    context: {
      kind: 'organization',
      key: 'care_console',
      env: (window.env.CARE_SUBENVIRONMENT || window.env.CARE_ENVIRONMENT).toLowerCase(),
    },
  });

  root.render(
    <LDProvider>
      <App />
    </LDProvider>
  );
})();
